// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DeleteDataRouteImport } from './routes/delete-data'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AgenciesRouteImport } from './routes/agencies'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EsBlogRouteImport } from './routes/es.blog'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as CheckoutPriceIdRouteImport } from './routes/checkout.$priceId'
import { Route as DeleteDataStatusRouteImport } from './routes/delete-data.status'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppInboxRouteImport } from './routes/_app.inbox'
import { Route as AppGrowthRouteImport } from './routes/_app.growth'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppCreativeRouteImport } from './routes/_app.creative'
import { Route as AppContentRouteImport } from './routes/_app.content'
import { Route as AppCompetitorsRouteImport } from './routes/_app.competitors'
import { Route as AppClientsRouteImport } from './routes/_app.clients'
import { Route as AppCampaignsRouteImport } from './routes/_app.campaigns'
import { Route as AppBenchmarksRouteImport } from './routes/_app.benchmarks'
import { Route as AppAudiencesRouteImport } from './routes/_app.audiences'
import { Route as AppAiStudioRouteImport } from './routes/_app.ai-studio'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as EsBlogIndexRouteImport } from './routes/es.blog.index'
import { Route as EsBlogSlugRouteImport } from './routes/es.blog.$slug'
import { Route as AppBillingPlansRouteImport } from './routes/_app.billing.plans'
import { Route as AppCampaignsNewRouteImport } from './routes/_app.campaigns.new'
import { Route as AppCampaignsCampaignIdRouteImport } from './routes/_app.campaigns.$campaignId'
import { Route as AppAdminAuditRouteImport } from './routes/_app.admin.audit'
import { Route as AppCampaignsCampaignIdApproveRouteImport } from './routes/_app.campaigns.$campaignId.approve'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DeleteDataRoute = DeleteDataRouteImport.update({
            id: '/delete-data',path: '/delete-data',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AgenciesRoute = AgenciesRouteImport.update({
            id: '/agencies',path: '/agencies',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EsBlogRoute = EsBlogRouteImport.update({
            id: '/es/blog',path: '/es/blog',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const CheckoutPriceIdRoute = CheckoutPriceIdRouteImport.update({
            id: '/checkout/$priceId',path: '/checkout/$priceId',getParentRoute: () => rootRouteImport
          })
const DeleteDataStatusRoute = DeleteDataStatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => DeleteDataRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppInboxRoute = AppInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AppRoute
          })
const AppGrowthRoute = AppGrowthRouteImport.update({
            id: '/growth',path: '/growth',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppCreativeRoute = AppCreativeRouteImport.update({
            id: '/creative',path: '/creative',getParentRoute: () => AppRoute
          })
const AppContentRoute = AppContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AppRoute
          })
const AppCompetitorsRoute = AppCompetitorsRouteImport.update({
            id: '/competitors',path: '/competitors',getParentRoute: () => AppRoute
          })
const AppClientsRoute = AppClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AppRoute
          })
const AppCampaignsRoute = AppCampaignsRouteImport.update({
            id: '/campaigns',path: '/campaigns',getParentRoute: () => AppRoute
          })
const AppBenchmarksRoute = AppBenchmarksRouteImport.update({
            id: '/benchmarks',path: '/benchmarks',getParentRoute: () => AppRoute
          })
const AppAudiencesRoute = AppAudiencesRouteImport.update({
            id: '/audiences',path: '/audiences',getParentRoute: () => AppRoute
          })
const AppAiStudioRoute = AppAiStudioRouteImport.update({
            id: '/ai-studio',path: '/ai-studio',getParentRoute: () => AppRoute
          })
const AppAdminRoute = AppAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AppRoute
          })
const EsBlogIndexRoute = EsBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EsBlogRoute
          })
const EsBlogSlugRoute = EsBlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => EsBlogRoute
          })
const AppBillingPlansRoute = AppBillingPlansRouteImport.update({
            id: '/billing/plans',path: '/billing/plans',getParentRoute: () => AppRoute
          })
const AppCampaignsNewRoute = AppCampaignsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AppCampaignsRoute
          })
const AppCampaignsCampaignIdRoute = AppCampaignsCampaignIdRouteImport.update({
            id: '/$campaignId',path: '/$campaignId',getParentRoute: () => AppCampaignsRoute
          })
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AppAdminRoute
          })
const AppCampaignsCampaignIdApproveRoute = AppCampaignsCampaignIdApproveRouteImport.update({
            id: '/approve',path: '/approve',getParentRoute: () => AppCampaignsCampaignIdRoute
          })





const AppAdminRouteChildren = {
  AppAdminAuditRoute: AppAdminAuditRoute
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(AppAdminRouteChildren)




const AppCampaignsCampaignIdRouteChildren = {
  AppCampaignsCampaignIdApproveRoute: AppCampaignsCampaignIdApproveRoute
}

const AppCampaignsCampaignIdRouteWithChildren = AppCampaignsCampaignIdRoute._addFileChildren(AppCampaignsCampaignIdRouteChildren)



const AppCampaignsRouteChildren = {
  AppCampaignsCampaignIdRoute: AppCampaignsCampaignIdRouteWithChildren,AppCampaignsNewRoute: AppCampaignsNewRoute
}

const AppCampaignsRouteWithChildren = AppCampaignsRoute._addFileChildren(AppCampaignsRouteChildren)



const AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,AppAiStudioRoute: AppAiStudioRoute,AppAudiencesRoute: AppAudiencesRoute,AppBenchmarksRoute: AppBenchmarksRoute,AppCampaignsRoute: AppCampaignsRouteWithChildren,AppClientsRoute: AppClientsRoute,AppCompetitorsRoute: AppCompetitorsRoute,AppContentRoute: AppContentRoute,AppCreativeRoute: AppCreativeRoute,AppDashboardRoute: AppDashboardRoute,AppGrowthRoute: AppGrowthRoute,AppInboxRoute: AppInboxRoute,AppSettingsRoute: AppSettingsRoute,AppBillingPlansRoute: AppBillingPlansRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const DeleteDataRouteChildren = {
  DeleteDataStatusRoute: DeleteDataStatusRoute
}

const DeleteDataRouteWithChildren = DeleteDataRoute._addFileChildren(DeleteDataRouteChildren)




const EsBlogRouteChildren = {
  EsBlogSlugRoute: EsBlogSlugRoute,EsBlogIndexRoute: EsBlogIndexRoute
}

const EsBlogRouteWithChildren = EsBlogRoute._addFileChildren(EsBlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AgenciesRoute: AgenciesRoute,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,CookiesRoute: CookiesRoute,DeleteDataRoute: DeleteDataRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,VerifyEmailRoute: VerifyEmailRoute,CheckoutPriceIdRoute: CheckoutPriceIdRoute,CheckoutReturnRoute: CheckoutReturnRoute,EsBlogRoute: EsBlogRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)